import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ApiCallerService } from '../services/api-caller.service';
import { AngularFireDatabase } from 'angularfire2/database';
import { Pipe, PipeTransform } from '@angular/core';



@Component({
  selector: 'app-top-info-block',
  templateUrl: './top-info-block.component.html',
  styleUrls: ['./top-info-block.component.css']
})
// @Pipe({ name: 'reverse' })

// export class ReversePipe implements PipeTransform {
//   transform(value) {
//     return value.slice().reverse();
//   }
// }
export class TopInfoBlockComponent implements OnInit {

@Output() selectedUser = new EventEmitter();

allAnswers;
counter = 0;

userChoice(event){

	this.selectedUser.emit(event);
}

// getColor(i){
  
//   let test = false;
//   for (let entry of this.foo) {
//     if (entry == i) {
//       true;
//       return;
//     }
//   }
//   if (!test){
//     console.log("value "+ i);
//     this.foo.push(i);

//   console.log(this.foo);
//   var value = this.counter;
//   this.counter++;
//   if (this.counter == 5)
//     this.counter = 0;
//   return "block"+value;

//   }
// }

// getColor(i){
//   return "block"+ i%5;
// }


  constructor(
    private service: ApiCallerService,
    private db: AngularFireDatabase) { }

  ngOnInit() {


    // this.service.selectedTrack = 1;
    // this.service.sessionId = "669343";

    this.db.list('/Session-'+this.service.sessionId + "/textAnswer").valueChanges().subscribe((answer : any) => {
      this.allAnswers = answer;
      this.allAnswers.reverse();
    });


  }

}
